module.exports = __webpack_public_path__ + "static/media/ss-vocab-old.a51dd5c7.gif";